<script setup>
  import { storeToRefs } from "pinia";
  import { useRouter } from "vue-router";
  import { useSurveyStore } from "@stores/survey/survey";
  import { useReportsV2Store } from "@stores/survey/reportsV2/reportsV2";
  import { ReportV2Form } from "@/components/Reports/ReportV2Form";

  const router = useRouter();

  const surveyStore = useSurveyStore();
  const { token: surveyToken } = storeToRefs(surveyStore);

  const reportsStore = useReportsV2Store();

  function goBack() {
    router.push({
      name: "SurveyReportsV2",
      params: { token: surveyToken.value },
    });
  }

  async function handleSubmit(params) {
    try {
      const report = await reportsStore.createReport(params);
      router.push({
        name: "ReportV2Slides",
        params: {
          token: surveyToken.value,
          reportToken: report.token,
        },
      });
    } catch (error) {
      console.error("Failed to create report:", error);
    }
  }
</script>

<template>
  <div class="p-6">
    <ReportV2Form
      mode="create"
      @submit="handleSubmit"
      @cancel="goBack" />
  </div>
</template>
